(function () {
  'use strict';

  angular
    .module('app.product-kit', [])

    .component('kitComponents', {
      templateUrl: '/Template/Product/KitComponents',
      require: {
        productCtrl: '^^productDetail'
      },
      bindings: {
        idKit: '@',
        kitSelection: '<',
        device: '<',
        productData: '<'
      },
      /* @ngInject */
      controller: ["$rootScope", "productService", "HttpService", function ($rootScope, productService, HttpService) {
        var ctrl = this;

        ctrl.attributes = {};

        ctrl.$onInit = function () {
          ctrl.kitSelection = ctrl.kitSelection || { quantity: 0, edit: false };
          ctrl.requiredQuantity = parseInt(ctrl.kitSelection.quantity);
          if (ctrl.requiredQuantity > 0) {
            $rootScope.$broadcast('updateProduct');
            productService.setKitRequiredQuantity(ctrl.idKit, ctrl.requiredQuantity);
          }
          ctrl.showLoader = true;
          getComponents(ctrl.idKit);
        };

        ctrl.changeAttribute = function (uniqueId) {
          var current;
          _.each(ctrl.Components, function (component) {
            if (component.uniqueId === uniqueId) {
              current = component;
              return false;
            }
          });

          var url = current.url;
          _.each(ctrl.attributes[uniqueId], function (attr) {
            url = attr === '' ? url : url + '/' + attr;
          });
          current.showLoader = true;
          current.UrlKit = url + '?view=KitProduct';
        };

        ctrl.loadedKitProduct = function (component, idProduct, isPrimary) {
          component.showLoader = false;
          productService.pushElement(ctrl.idKit, component.uniqueId, idProduct, isPrimary, component.KitQuantity);
          if (ctrl.Components.length === productService.getProduct()[ctrl.idKit].Elements.length) {
            $rootScope.$broadcast('updateProduct');
            $rootScope.$broadcast('updateComment', productService.getProduct()[ctrl.idKit].Comment);
            ctrl.showLoader = false;
          }
        };

        // Functions

        function getComponents(id) {
          HttpService.post({
            url: '/Product/GetComponents',
            data: id
          })
          .then(function (response) {
            if (response.status === 'OK') {
              if (!response.results.length) {
                ctrl.showLoader = false;
              }

              ctrl.Components = response.results;
              var i = 0;
              _.each(ctrl.Components, function (component) {
                component.uniqueId = component.IDProduct + '_' + i;
                ctrl.attributes[component.uniqueId] = [];
                component.UrlKit = component.URL + '?view=KitProduct';
                component.EditComponentQuantity = ctrl.kitSelection.edit;
                if (component.EditComponentQuantity) {
                  component.setQuantity = function (qty) {
                    component.KitQuantity = qty;
                    productService.updateElementQuantity(ctrl.idKit, component.uniqueId, component.KitQuantity);
                    $rootScope.$broadcast('updateProduct');
                  };
                }
                i++;
              });

            }
          })
          .catch(function (error) {
            console.error(error);
          });
        }

      }],
      controllerAs: 'kitCtrl'
    })

    /* @ngInject */
    .directive('kitProduct', function () {
      return {
        restrict: 'E',
        require: {
          kitCtrl: '^^kitComponents'
        },
        bindToController: {
          component: '<',
          idProduct: '<',
          url: '@productUrl',
          isPrimary: '<'
        },
        controller: function () {
          this.$onInit = function () {
            this.component.IDProduct = this.idProduct;
            this.component.url = this.url;
            this.kitCtrl.loadedKitProduct(this.component, this.idProduct, this.isPrimary);
          };
        }
      };
    });

})();
